import request from "@src/utils/request";
import {
  ClinicUserRole,
  ClinicUserStatus,
} from "@src/constants/ClinicUserConstants";

export interface TeamMember {
  id: string;
  userId: string;
  fullName: string;
  email: string;
  role: ClinicUserRole;
  status: ClinicUserStatus;
  isDefault: boolean;
  lastLogin: string | null;
}

export function listTeamMembers() {
  return request().get("/api/v1/clinic-team/").send();
}

export interface UpdateTeamMemberPayload {
  status?: ClinicUserStatus;
  role?: ClinicUserRole;
}

export function updateTeamMember(
  clinicUserId: string,
  payload: UpdateTeamMemberPayload,
) {
  return request()
    .patch(`/api/v1/clinic-team/${clinicUserId}/`)
    .send(payload);
}

export interface InviteTeamMemberPayload {
  firstName: string;
  lastName: string;
  email: string;
  role: ClinicUserRole;
}

export function inviteTeamMember(payload: InviteTeamMemberPayload) {
  return request().post("/api/v1/clinic-team/").send(payload);
}
